export default {
  showSuccessWindow (state, value) {
    state.success = value
  },
  errorMessage (state, value) {
    state.error = value
  },
  load (state, value) {
    state.load = value
  }
}
